<template>
  <form>
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <label for="salon-logo" class="form-label">Logo <span class="text-danger">*</span></label>
          <input type="file" class="form-control" id="salon-logo" />
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-group">
          <label for="salon-name" class="form-label">Name <span class="text-danger">*</span></label>
          <input type="text" class="form-control" id="salon-name" placeholder="Enter Your Salon Name" />
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-group">
          <label for="salon-slug" class="form-label">Slug <span class="text-danger">*</span></label>
          <input type="text" class="form-control" id="salon-slug" placeholder="Auto Generated By Salon Name" />
        </div>
      </div>
    </div>
  </form>
</template>
